<div class="header">
  <nav class="navbar navbar-expand-lg navbar-light"
    style="position: fixed;width: 100%;z-index: 1000;background-color: #EEF1FF;border-radius: 20px;">
    <div class="container" style="margin-top:1em;">
      <a class="navbar-brand" href="#">
        <img src="assets/images/logo.svg" alt="Logo" width="180"> <!-- Coloca aquí la ruta a tu logo -->
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <div class="row">
            <div class="col">
              <button class="btn btn-primary downloadButton">Descarga la App</button>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </nav>

  <div style="padding-left:8%;padding-right: 8%;">

    <div style="padding-top:180px;"></div>
    <div class="row" style="display:flex;align-items: start;">
      <div class="col-md-8">
        <h1 style="font-weight: 600;font-size: 4em;color: #222222;">Hola! soy</h1>
        <h1 style="font-weight: 700;font-size: 5em;color: #022C68;">{{userDetail.userData.name}}</h1>
        <p style="padding-top:1em;font-size:20px;font-weight: 500;">
          {{userDetail.userData.description}} </p>
        <div class="row" style="padding-top:20px;">
          <div class="col-md-6">
            <div class="row" style="display:flex;align-items: center">
              <div class="col-md-1">
                <i class="material-icons" style="font-size: 30px;color:#022C68;">phone</i>
              </div>
              <div class="col-md-11">
                <p style="padding-left:10px;font-size:20px;font-weight: 500;">{{userDetail.userData.phoneNumber}}</p>
              </div>
            </div>

          </div>
          <div class="col-md-6">
            <div class="row" style="display:flex;align-items: center">
              <div class="col-md-1">
                <i class="material-icons" style="font-size: 30px;color:#022C68;">mail</i>
              </div>
              <div class="col-md-11">
                <p style="padding-left:10px;font-size:20px;font-weight: 500;">{{userDetail.userData.email}}</p>
              </div>
            </div>

          </div>

        </div>

      </div>
      <div class="col-md-4 centered">
        <div class="circle">
          <img src="{{userDetail.userData.photo}}" alt="Imagen">
        </div>
      </div>
    </div>
    <div class="row" style="padding-top:50px">
      <div class="col text-center">
        <h2 style="font-size:80px;font-weight: 700;">{{userDetail.userData.seniority}}</h2>
        <h3 style="font-size:30px;font-weight:500">Con cammel</h3>
      </div>
      <div class="col text-center">
        <div class="" style="display:flex;align-items: center;justify-content: center;">
          <span class="material-icons-round " style="font-size:80px;color:#FCC20F;">
            star
          </span>
          <h2 style="font-size:80px;font-weight: 700;">{{userDetail.userData.averageScore}}</h2>
        </div>


        <h3 style="font-size:30px;font-weight:500">Puntuación <br> promedio</h3>
      </div>
      <div class="col text-center">
        <h2 style="font-size:80px;font-weight: 700;">{{userDetail.userData.totalWorks}}</h2>
        <h3 style="font-size:30px;font-weight:500">Trabajos <br> realizados</h3>
      </div>
    </div>
    <hr style="margin-top:2em;border: 2px solid #8c8f9b;border-radius: 2px;" />
    <div style="padding-top:2em;">
      <h1 style="font-size:30px;font-weight:700">Categorias destacadas</h1>
    </div>
    <div class="row" style="padding-top:2em;display:flex;justify-content: center;">
      @for (category of userDetail.categories; track category.categoryId){
      <div class="col-md-4" style="margin-bottom:40px;">
        <div class="card category-card">
          <div class="card-body" style="padding-top:5%;padding-bottom:5%;padding-left:10%;padding-right: 10%;">
            <div class="row text-center" style="display:flex;justify-content: center;">
              <div class="col-md-5 text-center" style="margin-top:auto;margin-bottom:auto;">
                <div class="width:100%" style="display:flex;align-items: center;justify-content: center;">

                  <div
                    style="width:70%;padding-top:70%;border-radius: 50%;position:relative;display: flex; justify-content: center; align-items: center;"
                    [ngStyle]="{'background-color':findCategorySpecs(category.categoryId).color}">
                    <img src="{{findCategorySpecs(category.categoryId).image}}" alt=""
                      style="width: 60%;position:absolute;top:50%;left:50%;transform: translate(-50%, -50%)">

                  </div>

                </div>
                <div style="padding-top:1em;">
                  <h4 style="font-size:14px;color:#4E4E4E;font-weight: 700;">{{category.category}}</h4>
                </div>
                <div style="display:flex;align-items: center;justify-content: center;margin-top: 1em;">
                  <div style="display:block;align-items: center;justify-content: center;width: 50%;">
                    <div style="background-color:#EEF1FF;border-radius: 5px;">
                      <p
                        style="display:flex;justify-content: center;align-items: center;color:4E4E4E;font-weight: 700;font-size:17px;padding-top:5px;padding-bottom:5px;padding-left:10px;padding-right:10px;">
                        <span class="material-icons-round " style="color:#FCC20F;">
                          star
                        </span>{{category.averageScore}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2" style="display:flex;align-items: center;justify-content: center;">
                <div class="vertical-line"
                  style="width: 3px;height:100%;background-color: #EEF1FF;border-radius: 10px;"></div>
              </div>
              <div class="col-md-5 text-center" style="margin-top:auto;margin-bottom:auto;">
                <div class="width:100%" style="display: flex;align-items: center;justify-content: center;">
                  <span class="material-icons-round" style="font-size:5em;color:#044AAE;">
                    workspace_premium
                  </span>
                </div>
                <h3 style="font-size: 60px;font-weight:700;color:#022C68">{{category.totalWorks}}</h3>
                <h4 style="font-size:18px;font-weight: 600;color:#022C68;">Trabajos realizados</h4>
              </div>

            </div>
          </div>
        </div>
      </div>
      }
      @empty {

      }

    </div>

    <hr style="margin-top:2em;border: 2px solid #8c8f9b;border-radius: 2px;" />
    <div style="padding-top:2em;">
      <h1 style="font-size:30px;font-weight:700">Valoraciones destacadas</h1>
    </div>
    <div class="row text-center" style="margin-top:3em;">

      @for (highlight of userDetail.highlights; track highlight.title){
      <div class="col-md-3">
        <div style="display:flex;align-items: center;justify-content: center;">
          <div class="circle-container">
            <div class="circle1">
              <span class="material-icons-round" style="font-size: 5em;position: absolute;top:50%;left:50%;transform: translate(-50%, -50%); 
                z-index: 1;color:#022C68;">
                {{highlight.imageIcon}}
              </span>
            </div>
            <div class="rectangle">
              <p style="font-weight: 700;font-size: 100%;position: absolute;top:50%;left:50%;transform: translate(-50%, -50%); 
              z-index: 1;color:#022C68">{{highlight.total}}</p>
            </div>
          </div>
        </div>
        <div style="padding-top:1em;padding-bottom:2em;padding-left:5em;padding-right:5em;">
          <p style="font-size:18px;font-weight: 500;color:#022C68">{{highlight.title}}</p>
        </div>
      </div>
      } @empty{

      }


    </div>

    <hr style="margin-top:2em;border: 2px solid #8c8f9b;border-radius: 2px;" />
    <div style="padding-top:2em;">
      <h1 style="font-size:30px;font-weight:700">Comentarios destacados</h1>
    </div>
    <div style="padding-left:10%;padding-right:10%;">

      @for (comment of userDetail.comments;track comment.commentId){

      @if (comment.commentId % 2 != 0) {
      <div style="margin-top:3em;display:flex;align-items: end;justify-content: end;">
        <div class="message-container">
          <p style="padding-left:5%;padding-right:5%;padding-top:5%;font-style: italic;color:#022C68;font-size: 18px;">
            "{{comment.message}}"</p>
          <div style="display:flex;justify-content: end;">
            <p style="padding-left:5%;padding-right:5%;color:#022C68;font-weight: 700;">{{comment.username}}</p>
          </div>

        </div>
        <span class="material-icons-round" style="font-size: 40px;color:#391F66;">
          person
        </span>
      </div>
      } @else {
      <div style="margin-top:3em;display:flex;align-items: end;justify-content: start;">
        <span class="material-icons-round" style="font-size: 40px;color:#022C68;">
          person
        </span>
        <div class="message-container-response">
          <p style="padding-left:5%;padding-right:5%;padding-top:5%;font-style: italic;color:#022C68;font-size: 18px;">
            "{{comment.message}}"</p>
          <div style="display:flex;justify-content: start;">
            <p style="padding-left:5%;padding-right:5%;color:#022C68;font-weight: 700;">{{comment.username}}</p>
          </div>

        </div>

      </div>
      }




      } @empty{

      }




    </div>

  </div>
  <footer style="margin-top:100px;">
    <div style="width:100%;background-color:#EEF1FF;box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1);border-radius: 20px; ">
      <div class="container">
        <div class="row" style="padding-top:30px;padding-left: 8%;padding-right: 8%;">
          <div class="col">
            <ul style="padding-top:2em;list-style-type: none;text-decoration: none;">
              <li><a href="#" style="text-decoration: none;">Únete a Cammel</a></li>
              <li><a href="#" style="text-decoration: none;">Política de privacidad</a></li>
              <li><a href="#" style="text-decoration: none;">Términos y condiciones</a></li>
            </ul>
          </div>
          <div class="col" style="display:flex;justify-content: end;align-items: center;">
            <a href=""><img src="assets/images/instagram_logo.png" alt="instagram_logo"
                style="width:50px;margin-right:15px;"></a>
            <a href=""><img src="assets/images/x_logo.png" alt="x_logo" style="width:50px;margin-right:15px;"></a>
            <a href=""><img src="assets/images/LinkedIn_logo.png" alt="Linkedin_logo"
                style="width:50px;margin-right:15px;"></a>
          </div>
        </div>
        <div class="row" style="display:flex;align-items: center;">
          <div class="col">
            <div>
              <a href="#" style="text-decoration: none;align-items: center;display: flex;justify-content: center;">
                <img src="assets/images/download_app_store.png" alt="apple_logo" style="width:50%;">
              </a>
            </div>
          </div>
          <div class="col" style="text-decoration: none;">
            <div style="display:flex;align-items: center;justify-content: center;">
              <a href="#" style="text-decoration: none;display: flex;justify-content: center;">
                <img src="assets/images/download_play_store.png" alt="play_store_logo" style="width:60%;">
              </a>
            </div>
          </div>


        </div>
      </div>
      <div class="text-center" style="padding-top:40px;padding-bottom:20px;">
        <p>Cammel S.A &copy; 2024</p>
      </div>
    </div>
  </footer>
</div>